import React, { useState } from 'react';
import './GetInvolved.css';

const slices = [
  { label: 'Food',                   amount: 8792.94, color: '#1B3A2D', desc: 'Fresh ingredients for every mission, further subsidized through food donations' },
  { label: 'Merch',                  amount: 2141.90, color: '#C9903A', desc: 'Organization merchandise sold at a profit, returning funds to the mission' },
  { label: 'Kitchen',                amount: 963.12,  color: '#3D7059', desc: 'Startup costs for our outdoor kitchen, built to support growing mission demand' },
  { label: 'Fundraising',            amount: 719.57,  color: '#E8B76A', desc: 'Costs associated with hosting fundraising events' },
  { label: 'Insurance',              amount: 627.88,  color: '#2A5240', desc: 'Required coverage for operating a food kitchen' },
  { label: 'Resources for Neighbors',amount: 595.99,  color: '#8B6914', desc: 'Clothing, hygiene supplies, hand warmers, transportation, legal documents, and spiritual materials' },
  { label: 'Organization Costs',     amount: 353.40,  color: '#5A8A72', desc: 'Filing and administrative costs of operating as a 501(c)(3)' },
  { label: 'Garden',                 amount: 155.49,  color: '#A8C5B5', desc: 'Garden plot and growing supplies for fresh produce' },
];

const total = slices.reduce((s, d) => s + d.amount, 0);

// Build SVG pie chart path data
const buildPaths = () => {
  let cumulative = 0;
  return slices.map((slice) => {
    const pct = slice.amount / total;
    const startAngle = cumulative * 2 * Math.PI - Math.PI / 2;
    cumulative += pct;
    const endAngle = cumulative * 2 * Math.PI - Math.PI / 2;
    const cx = 160, cy = 160, r = 130, inner = 72;
    const x1 = cx + r * Math.cos(startAngle);
    const y1 = cy + r * Math.sin(startAngle);
    const x2 = cx + r * Math.cos(endAngle);
    const y2 = cy + r * Math.sin(endAngle);
    const ix1 = cx + inner * Math.cos(endAngle);
    const iy1 = cy + inner * Math.sin(endAngle);
    const ix2 = cx + inner * Math.cos(startAngle);
    const iy2 = cy + inner * Math.sin(startAngle);
    const large = pct > 0.5 ? 1 : 0;
    const d = `M ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} L ${ix1} ${iy1} A ${inner} ${inner} 0 ${large} 0 ${ix2} ${iy2} Z`;
    return { ...slice, d, pct };
  });
};

const paths = buildPaths();

const PieChart = () => {
  const [hovered, setHovered] = useState(null);
  const active = hovered !== null ? slices[hovered] : null;

  return (
    <div className="gi-chart-wrap">
      <svg viewBox="0 0 320 320" className="gi-pie">
        {paths.map((slice, i) => (
          <path
            key={i}
            d={slice.d}
            fill={slice.color}
            stroke="#F7F3EC"
            strokeWidth="2"
            className={`gi-slice ${ 'gi-slice-hover' }`}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
          />
        ))}
        {/* Center text */}
        <text x="160" y="152" textAnchor="middle" className="gi-pie-center-label">
          {active ? `$${active.amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` : 'Total Spent'}
        </text>
        <text x="160" y="172" textAnchor="middle" className="gi-pie-center-sub">
          {active ? active.label : '$14,349'}
        </text>
      </svg>

      {/* Legend */}
      <div className="gi-legend">
  {paths.map((s, i) => (
    <div
      key={i}
      className={`gi-legend-item ${hovered === i ? 'gi-legend-active' : ''}`}
      onMouseEnter={() => setHovered(i)}
      onMouseLeave={() => setHovered(null)}
    >
      <span className="gi-legend-dot" style={{ background: s.color }} />
      <div className="gi-legend-text">
  <span className="gi-legend-name">{s.label}</span>
  <span className="gi-legend-pct">${s.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })} &nbsp;·&nbsp; {(s.pct * 100).toFixed(1)}%</span>
  <span className="gi-legend-desc">{s.desc}</span>
</div>
    </div>
  ))}
</div>
    </div>
  );
};

const GetInvolved = () => {
  return (
    <div className="gi-page">

      {/* ── HERO ── */}
      <div className="gi-hero">
        <div className="gi-hero-bg" style={{ backgroundImage: 'url(../../../Images/Picture.png)' }} />
        <div className="gi-hero-overlay" />
        <div className="gi-hero-content">
          <p className="gi-eyebrow">Food for Thought</p>
          <h1>Support Our Mission</h1>
          <a
            href="https://www.zeffy.com/en-US/donation-form/donate-to-make-a-difference-7510"
            target="_blank"
            rel="noreferrer"
            className="gi-hero-btn"
          >
            Donate Now
          </a>
        </div>
      </div>

      {/* ── STATS ROW ── */}
      <section className="gi-stats">
        <div className="gi-stats-inner">
          <div className="gi-stat">
            <span className="gi-stat-number">$20,420</span>
            <span className="gi-stat-label">Total Funds Raised</span>
          </div>
          <div className="gi-stat">
            <span className="gi-stat-number">$14,349</span>
            <span className="gi-stat-label">Total Funds Spent</span>
          </div>
          <div className="gi-stat">
            <span className="gi-stat-number">~$1,400</span>
            <span className="gi-stat-label">Monthly Operating Cost</span>
          </div>
          <div className="gi-stat">
            <span className="gi-stat-number">$3</span>
            <span className="gi-stat-label">Average Cost Per Meal</span>
          </div>
        </div>
      </section>

         {/* ── DONATE CTA ── */}
      <section className="gi-section gi-cta-section">
        <div className="gi-section-inner gi-cta-inner">
          <div className="gi-cta-text">
            <h2>Every Dollar Feeds a Neighbor</h2>
            <p className="gi-intro">
              Just $25 a month supplies 8 shared meals. Currently less than 15% of our funding comes from recurring monthly donors. A monthly gift allows us to plan ahead, show up consistently, and continue our mission. 
            </p>
            <a
              href="https://www.zeffy.com/en-US/donation-form/donate-to-make-a-difference-7510"
              target="_blank"
              rel="noreferrer"
              className="gi-donate-btn"
            >
              Donate on Zeffy →
            </a>
            <p className="gi-zeffy-note">
              Zeffy is a 100% free platform — no fees taken from your donation.
            </p>
          </div>
          <div className="gi-cta-contact">
            <h3>Contact Us</h3>
            <p>For any inquiries about donating or partnering with Food for Thought, reach out to Paul Selberg directly.</p>
            <a href="tel:4147502031" className="gi-contact-line">📞 414-750-2031</a>
            <a href="mailto:paulselberg1@gmail.com" className="gi-contact-line">✉️ paulselberg1@gmail.com</a>
          </div>
        </div>
      </section>

      {/* ── FINANCIAL BREAKDOWN ── */}
<section className="gi-section" style={{ paddingTop: '2rem' }}>        <div className="gi-section-inner">
          <h2>Where Your Money Goes</h2>
          <p className="gi-intro">
            Food for Thought is a 501(c)(3) nonprofit that is fully volunteer-run, ensuring every
            donation goes directly toward our mission. 
          </p>
          <PieChart />
        </div>
      </section>

      {/* ── GRANT ── */}
      <section className="gi-grant">
        <div className="gi-grant-inner">
          <div className="gi-grant-badge">🏆 Grant Awarded</div>
          <div className="gi-grant-amount">$17,711</div>
          <p className="gi-grant-period">July 2026 – July 2027</p>
          <p className="gi-grant-desc">
            This grant covers operational and new initiative costs beyond food, allowing donor
            contributions to go directly toward meals and neighbor resources.
          </p>
        </div>
      </section>

   

    </div>
  );
};

export default GetInvolved;